export default __webpack_public_path__ + "static/media/002-camping.420b8692.png";